import React, { useState } from "react";

const FileUpload = ({ onUpload }) => {
  const [dragActive, setDragActive] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleFileInput = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFiles(e.target.files);
    }
  };

  const handleFiles = async (files) => {
    setUploading(true);
    setUploadMessage("Uploading files...");

    try {
      const formData = new FormData();
      Array.from(files).forEach((file) => {
        formData.append("files", file);
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL || ""}/api/upload`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok) {
        setUploadMessage(
          `Successfully uploaded ${Object.keys(data.files).length} files`
        );
        onUpload(data);
      } else {
        setUploadMessage(`Upload failed: ${data.detail}`);
      }
    } catch (error) {
      setUploadMessage(`Upload error: ${error.message}`);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="file-upload">
      <div className="upload-header">
        <h3 style={{ color: "#f5f5f5" }}>📤 Upload Files</h3>
      </div>

      <div
        className={`upload-area ${dragActive ? "drag-active" : ""}`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <div className="upload-content">
          <div className="upload-icon">📁</div>
          <h4
            style={{ color: "#f5f5f5", fontSize: "16px", marginBottom: "12px" }}
          >
            Drop files here or click to browse
          </h4>
          <input
            type="file"
            multiple
            accept=".pli,.pl1,.txt,.inc,.cpy,.zip,.cs,.uitest,.feature,.csproj,.config,.js,.ts,.json"
            onChange={handleFileInput}
            className="file-input"
            disabled={uploading}
          />
          <button
            className="browse-button"
            onClick={() => document.querySelector(".file-input").click()}
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Browse Files"}
          </button>
        </div>
      </div>

      {uploadMessage && (
        <div
          className={`upload-message ${
            uploadMessage.includes("Successfully") ? "success" : "error"
          }`}
        >
          {uploadMessage}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
